export const EMPTY_CONTENT = '<p></p>';
export const FORMATTED_REGEX = /&nbsp;/g;
